/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PermissionFromJSON, PermissionToJSON, } from './Permission';
import { ResourceTypeFromJSON, ResourceTypeToJSON, } from './ResourceType';
/**
 * Check if a given object implements the PermissionDescriptor interface.
 */
export function instanceOfPermissionDescriptor(value) {
    var isInstance = true;
    return isInstance;
}
export function PermissionDescriptorFromJSON(json) {
    return PermissionDescriptorFromJSONTyped(json, false);
}
export function PermissionDescriptorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'targetResourceIds': !exists(json, 'targetResourceIds') ? undefined : json['targetResourceIds'],
        'resourceType': !exists(json, 'resourceType') ? undefined : ResourceTypeFromJSON(json['resourceType']),
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(PermissionFromJSON))
    };
}
export function PermissionDescriptorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'targetResourceIds': value.targetResourceIds,
        'resourceType': ResourceTypeToJSON(value.resourceType),
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(PermissionToJSON))
    };
}
